export const userServiceFields = <const>[
	'id',
	'serviceParameters.id',
	'serviceParameters.value',
	'serviceParameters.parameter.id',
	'serviceParameters.parameter.paramName',
	'serviceParameters.parameter.description',
	'serviceParameters.parameter.defaultValue',
	'service.id',
	'service.labelTranslationId',
	'service.descriptionTransId',
	'service.manageParameter',
	'member.id',
	'member.name',
	'supplier.id',
	'supplier.name',
	'diffusionPerson.personServiceParameters.parameter.id',
	'diffusionPerson.personServiceParameters.value'
];
